module.exports = __webpack_public_path__ + "img/seekingkindness.83cf693a.jpg";